const PREFIX = 'VOUCHER_PROGRAM_';

export const GET_VOUCHER_PROGRAM = `${PREFIX}GET_VOUCHER_PROGRAM`;
export const SAVE_VOUCHER_PROGRAM = `${PREFIX}SAVE_VOUCHER_PROGRAM`;
export const SET_VOUCHER_PROGRAM = `${PREFIX}SET_VOUCHER_PROGRAM`;